<template>
    <div class="pdf_view" @contextmenu.prevent.stop="">
        <pdf v-for="item in pageTotal" :src="pdfUrlShow" :key="item" :page="item">
        </pdf>
    </div>
</template>

<script>
import pdf from "vue-pdf";
export default {
    props: {
        pdfUrl: {
            type: String,
            default: ''
        },

    },
    components:{pdf},
    data() {
        return {
            pdfUrlShow: "",
            pageTotal: 0,
        }
    },
    watch: {
        pdfUrl(val) {
            
            this.pdfUrlShow = pdf.createLoadingTask(val);
            // 获取页码
            this.pdfUrlShow.promise.then((pdf) => (this.pageTotal = pdf.numPages))
                .catch((error) => { });
        }
    },

    computed: {

    },
    methods: {
        rightClick(){
            
        }
    },
    mounted() {
          console.log(123456);
           console.log(this.pdfUrl);
           this.pdfUrlShow = pdf.createLoadingTask(this.pdfUrl);
            // 获取页码
            this.pdfUrlShow.promise.then((pdf) => (this.pageTotal = pdf.numPages))
                .catch((error) => { });

    }
}
</script>

<style lang="scss" scoped>
.pdf_view {
    width: 100%;
    height:533px;
    overflow-y: auto;
    background-color: #666;
    border: 1px solid #D8D8D8;
}
</style>
